import { IEnvironment, defaultEnvironment } from './interface';

export const environment: IEnvironment = {
  ...defaultEnvironment,
  production: true,
  apiOrigin: 'https://nxtecom-staging.azurewebsites.net',
  buildOrigin: 'nxtecomfrontend-staging.azurewebsites.net',
};
